// extracted by mini-css-extract-plugin
export default {"align":"app-components-CreatePartialPerson-CreatePartialPersonForm-module__K7rN7wju9AViLfRVxvWF"};